import { Pipe, PipeTransform } from '@angular/core';
import { MissionPlace } from '../../models/mission/mission-place';

@Pipe({
	name: 'filterMissionPlaceBySpeciality'
})
export class FilterMissionPlaceBySpecialityPipe implements PipeTransform {
	transform(
		missionPlaces: MissionPlace[],
		specialityName: string
	): MissionPlace[] {
		if (!specialityName || !missionPlaces) {
			return missionPlaces;
		}

		return missionPlaces.filter((missionPlace) => {
			if (missionPlace.specialties !== null) {
				return missionPlace.specialties[0].name === specialityName;
			}
			return false;
		});
	}
}
